import Image from 'next/image';
import { useIntl } from 'react-intl';

import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { Money } from '@/graphql/saleor/api';
import type { Maybe } from '@/lib/types';
import { CembraMessage, commonMessages } from '@/messages/common';
import { useConfigProvider } from '@/providers/ConfigProvider';
import { useRegionProvider } from '@/providers/RegionProvider';

import CembraIcon from '@/assets/icons/cembra.svg';

import * as S from '../ProductDetail.styles';

interface CembraSentenceProps {
  onLearnMore: () => void;
  price: Maybe<Money>;
  variantCTA?: OrderAppCtaType;
}

export const CembraSentence = ({
  onLearnMore,
  price,
  variantCTA,
}: CembraSentenceProps) => {
  const { formatMessage } = useIntl();
  const { formatPrice } = useRegionProvider();

  const { cembraFinancingPaymentMax } = useConfigProvider();

  if (!price || variantCTA !== 'ORDER') return null;

  return (
    <Flex flexDirection='column'>
      {price.amount > (cembraFinancingPaymentMax as number) ? (
        <S.AdditionalCembraMessage data-testid='cembraAdditionalMessage'>
          {formatMessage(commonMessages.additionalCembraMessage)}
        </S.AdditionalCembraMessage>
      ) : (
        <Flex flexDirection='column'>
          <Flex alignItems='center'>
            <Typography fontFamily='openSans' scale='p1'>
              {CembraMessage(
                formatPrice({
                  amount: price.amount / 48,
                  currency: price.currency,
                }),
              )}
            </Typography>
            <Image alt='cembra' height={55} src={CembraIcon} width={88} />
          </Flex>
          <S.LearnMore
            data-testid='cembrabLearnMore'
            onClick={onLearnMore}
            style={{ marginTop: '-15px', marginBottom: 15 }}
          >
            {formatMessage(commonMessages.learnMore)}
          </S.LearnMore>
        </Flex>
      )}
    </Flex>
  );
};
